import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/squarespace': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M186.1 343.3l157.2-157.2c38.6-38.6 101.1-38.6 139.7 0 38.6 38.6 38.6 101.1 0 139.7l-119.3 119.2 0 0c-19.3 19.3-50.5 19.3-69.8 0l154.1-154.1c19.3-19.3 19.3-50.6 0-69.9s-50.6-19.3-69.9 0l-157.2 157.2c-9.6 9.6-25.3 9.6-34.9 0-9.7-9.7-9.7-25.3 0-34.9zM430.6 238.5c9.6 9.6 9.6 25.3 0 34.9l-157.2 157.2c-38.6 38.6-101.1 38.6-139.7 0l0 0c-9.6-9.7-9.6-25.3 0-34.9l0 0c9.6-9.6 25.3-9.6 34.9 0l0 0c19.3 19.3 50.5 19.2 69.8 0l157.2-157.2c9.6-9.7 25.3-9.7 34.9 0zM168.7 325.9c-38.6 38.6-101.1 38.6-139.7 0-38.6-38.6-38.6-101.1 0-139.7l119.2-119.3 0 0c19.3-19.3 50.6-19.3 69.9 0l-154.2 154.2 0 0c-19.3 19.3-19.3 50.6 0 69.8l0 0c19.3 19.3 50.6 19.3 69.8 0l157.2-157.2c9.6-9.6 25.3-9.6 34.9 0 9.6 9.7 9.6 25.3 0 34.9zM81.3 273.5c-9.6-9.6-9.7-25.3 0-34.9l157.2-157.2c38.6-38.6 101.1-38.6 139.7 0 9.6 9.6 9.6 25.3 0 34.9-9.6 9.6-25.3 9.6-34.9 0l0 0c-19.3-19.3-50.6-19.3-69.8 0l-157.2 157.2c-9.6 9.6-25.3 9.6-34.9 0z'
      }
    ]
  }
})
